// @ts-ignore
export const all = (state) => state.all;

// @ts-ignore
export const one = (state) => state.one;

export const newArticle = (state: any) => state.newArticle;

export const clickedBy = (state: any) => state.clickedBy;
